import { StyleSheet, View, Animated, Dimensions, Easing } from "react-native";
import React, { useEffect, useRef } from "react";

const LinearLoading = () => {
  const width = Dimensions.get("screen").width;
  const marginLeft = useRef(new Animated.Value(-100)).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(marginLeft, {
        toValue: (width * 90) / 100,
        duration: 1500,
        easing: Easing.ease,
        useNativeDriver: false,
      })
    ).start();
  }, []);
  return (
    <View style={styles.root}>
      <Animated.View
        style={[styles.bar, { marginLeft: marginLeft }]}
      ></Animated.View>
    </View>
  );
};

export default LinearLoading;

const styles = StyleSheet.create({
  root: {
    height: 4,
    backgroundColor: "rgb(188, 242, 242)",
    width: "90%",
    overflow: "hidden",
  },
  bar: {
    backgroundColor: "#4FDDDD",
    width: "40%",
    flex: 1,
  },
});
